// Registry of message namespaces. One JSON file per namespace per locale; the first segment of a
// message key is the namespace (e.g. t("bookings.list.title") lives in bookings.json under list.title).
import id_common from "./id/common.json" with { type: "json" };
import id_nav from "./id/nav.json" with { type: "json" };
import id_guestid from "./id/guestid.json" with { type: "json" };
import id_auth from "./id/auth.json" with { type: "json" };
import id_account from "./id/account.json" with { type: "json" };
import id_users from "./id/users.json" with { type: "json" };
import id_dashboard from "./id/dashboard.json" with { type: "json" };
import id_bookings from "./id/bookings.json" with { type: "json" };
import id_calendar from "./id/calendar.json" with { type: "json" };
import id_guests from "./id/guests.json" with { type: "json" };
import id_orders from "./id/orders.json" with { type: "json" };
import id_requests from "./id/requests.json" with { type: "json" };
import id_notifications from "./id/notifications.json" with { type: "json" };
import id_payments from "./id/payments.json" with { type: "json" };
import id_catalog from "./id/catalog.json" with { type: "json" };
import id_properties from "./id/properties.json" with { type: "json" };
import id_units from "./id/units.json" with { type: "json" };
import id_sites from "./id/sites.json" with { type: "json" };
import id_activities from "./id/activities.json" with { type: "json" };
import id_entitlements from "./id/entitlements.json" with { type: "json" };
import id_feedback from "./id/feedback.json" with { type: "json" };
import id_guest from "./id/guest.json" with { type: "json" };
import id_publicsite from "./id/publicsite.json" with { type: "json" };
import id_errors from "./id/errors.json" with { type: "json" };
import id_status from "./id/status.json" with { type: "json" };
import id_notif from "./id/notif.json" with { type: "json" };
import id_email from "./id/email.json" with { type: "json" };
import id_bookingdetail from "./id/bookingdetail.json" with { type: "json" };
import id_billing from "./id/billing.json" with { type: "json" };
import id_ledger from "./id/ledger.json" with { type: "json" };
import id_packages from "./id/packages.json" with { type: "json" };
import id_vouchers from "./id/vouchers.json" with { type: "json" };
import id_pricing from "./id/pricing.json" with { type: "json" };
import id_chat from "./id/chat.json" with { type: "json" };
import id_documents from "./id/documents.json" with { type: "json" };
import id_locationpicker from "./id/locationpicker.json" with { type: "json" };
import id_landing from "./id/landing.json" with { type: "json" };
import id_paylink from "./id/paylink.json" with { type: "json" };
import id_blocks from "./id/blocks.json" with { type: "json" };
import id_bnotif from "./id/bnotif.json" with { type: "json" };
import id_charges from "./id/charges.json" with { type: "json" };
import id_receipt from "./id/receipt.json" with { type: "json" };
import id_onboarding from "./id/onboarding.json" with { type: "json" };
import en_common from "./en/common.json" with { type: "json" };
import en_nav from "./en/nav.json" with { type: "json" };
import en_guestid from "./en/guestid.json" with { type: "json" };
import en_auth from "./en/auth.json" with { type: "json" };
import en_account from "./en/account.json" with { type: "json" };
import en_users from "./en/users.json" with { type: "json" };
import en_dashboard from "./en/dashboard.json" with { type: "json" };
import en_bookings from "./en/bookings.json" with { type: "json" };
import en_calendar from "./en/calendar.json" with { type: "json" };
import en_guests from "./en/guests.json" with { type: "json" };
import en_orders from "./en/orders.json" with { type: "json" };
import en_requests from "./en/requests.json" with { type: "json" };
import en_notifications from "./en/notifications.json" with { type: "json" };
import en_payments from "./en/payments.json" with { type: "json" };
import en_catalog from "./en/catalog.json" with { type: "json" };
import en_properties from "./en/properties.json" with { type: "json" };
import en_units from "./en/units.json" with { type: "json" };
import en_sites from "./en/sites.json" with { type: "json" };
import en_activities from "./en/activities.json" with { type: "json" };
import en_entitlements from "./en/entitlements.json" with { type: "json" };
import en_feedback from "./en/feedback.json" with { type: "json" };
import en_guest from "./en/guest.json" with { type: "json" };
import en_publicsite from "./en/publicsite.json" with { type: "json" };
import en_errors from "./en/errors.json" with { type: "json" };
import en_status from "./en/status.json" with { type: "json" };
import en_notif from "./en/notif.json" with { type: "json" };
import en_email from "./en/email.json" with { type: "json" };
import en_bookingdetail from "./en/bookingdetail.json" with { type: "json" };
import en_billing from "./en/billing.json" with { type: "json" };
import en_ledger from "./en/ledger.json" with { type: "json" };
import en_packages from "./en/packages.json" with { type: "json" };
import en_vouchers from "./en/vouchers.json" with { type: "json" };
import en_pricing from "./en/pricing.json" with { type: "json" };
import en_chat from "./en/chat.json" with { type: "json" };
import en_documents from "./en/documents.json" with { type: "json" };
import en_locationpicker from "./en/locationpicker.json" with { type: "json" };
import en_landing from "./en/landing.json" with { type: "json" };
import en_paylink from "./en/paylink.json" with { type: "json" };
import en_blocks from "./en/blocks.json" with { type: "json" };
import en_bnotif from "./en/bnotif.json" with { type: "json" };
import en_charges from "./en/charges.json" with { type: "json" };
import en_receipt from "./en/receipt.json" with { type: "json" };
import en_onboarding from "./en/onboarding.json" with { type: "json" };

export const idMessages = {
  common: id_common,
  nav: id_nav,
  guestid: id_guestid,
  auth: id_auth,
  account: id_account,
  users: id_users,
  dashboard: id_dashboard,
  bookings: id_bookings,
  calendar: id_calendar,
  guests: id_guests,
  orders: id_orders,
  requests: id_requests,
  notifications: id_notifications,
  payments: id_payments,
  catalog: id_catalog,
  properties: id_properties,
  units: id_units,
  sites: id_sites,
  activities: id_activities,
  entitlements: id_entitlements,
  feedback: id_feedback,
  guest: id_guest,
  publicsite: id_publicsite,
  errors: id_errors,
  status: id_status,
  notif: id_notif,
  email: id_email,
  bookingdetail: id_bookingdetail,
  billing: id_billing,
  ledger: id_ledger,
  packages: id_packages,
  vouchers: id_vouchers,
  pricing: id_pricing,
  chat: id_chat,
  documents: id_documents,
  locationpicker: id_locationpicker,
  landing: id_landing,
  paylink: id_paylink,
  blocks: id_blocks,
  bnotif: id_bnotif,
  charges: id_charges,
  receipt: id_receipt,
  onboarding: id_onboarding,
} as const;

export const enMessages = {
  common: en_common,
  nav: en_nav,
  guestid: en_guestid,
  auth: en_auth,
  account: en_account,
  users: en_users,
  dashboard: en_dashboard,
  bookings: en_bookings,
  calendar: en_calendar,
  guests: en_guests,
  orders: en_orders,
  requests: en_requests,
  notifications: en_notifications,
  payments: en_payments,
  catalog: en_catalog,
  properties: en_properties,
  units: en_units,
  sites: en_sites,
  activities: en_activities,
  entitlements: en_entitlements,
  feedback: en_feedback,
  guest: en_guest,
  publicsite: en_publicsite,
  errors: en_errors,
  status: en_status,
  notif: en_notif,
  email: en_email,
  bookingdetail: en_bookingdetail,
  billing: en_billing,
  ledger: en_ledger,
  packages: en_packages,
  vouchers: en_vouchers,
  pricing: en_pricing,
  chat: en_chat,
  documents: en_documents,
  locationpicker: en_locationpicker,
  landing: en_landing,
  paylink: en_paylink,
  blocks: en_blocks,
  bnotif: en_bnotif,
  charges: en_charges,
  receipt: en_receipt,
  onboarding: en_onboarding,
};
